export enum CustomerPhoneStatus {
  EMPTY= "EMPTY",
  FOREING_PHONE_NUMBER = "FOREING_PHONE_NUMBER",
  VERIFIED ="VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  INVALID_NUMBER = "INVALID_NUMBER"
}
